var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9797 8.97967C17.7116 8.71161 17.2798 8.70267 17.0009 8.95942L12 13.5628L6.9991 8.95942C6.72018 8.70267 6.2884 8.7116 6.02033 8.97967C5.73639 9.26361 5.74565 9.72675 6.04071 9.99912L11.3217 14.8739C11.7048 15.2275 12.2952 15.2275 12.6783 14.8739L17.9593 9.99912C18.2544 9.72675 18.2636 9.26361 17.9797 8.97967Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.6d0a55c9d97f22ff123d7258db8fc904.svg";
export { ForwardRef as ReactComponent };